/*
  作者：bai.zhiming
  时间：2017-3-2
  描述：采编中心-app渠道-编辑器插入组件弹窗控制器
*/
"use strict";
angular.module("insertComponentModule", [])
    .controller("insertComponentCtrl", ["$scope", "ue", "$modalInstance", "trsHttpService", function($scope, ue, $modalInstance, trsHttpService) {
        initStatus();
        initData();
        /**
         * [close 关闭]
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        /**
         * [initStatus 初始化状态]
         * @param {[obj]} [item] [description] 所插入的组件
         * @return {[type]} [description]
         */
        $scope.insertComponent = function(item) {
            var template = '<div contenteditable="false" class="wg wgVote">' +
                '<p data-id="' + item.id + '">' + item.title + '</p>' +
                '</div>';
            ue.execCommand("inserthtml", template);
            ue.fireEvent("contentChange");
        };
        /**
         * [pageChanged 切换页面]
         * @return {[type]} [description]
         */
        $scope.getComponentsList = function() {
            getComponentsList();
        };
        /**
         * [jumpToPage 页面指定跳转]
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            $scope.status.page.CURRPAGE = angular.copy($scope.status.page.COPYCURRPAGE);
            getComponentsList();
        };
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                page: {
                    CURRPAGE: 1,
                    PAGESIZE: 10
                }
            };
            $scope.data = {};
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getComponentsList();
        }
        /**
         * [getComponentsList 获取组件列表]
         * @return {[type]} [description]
         */
        function getComponentsList() {
            var params = {
                serviceid: "mlf_appexchange",
                methodname: "queryVotes",
                pageIndex: $scope.status.page.CURRPAGE,
                pageSize: $scope.status.page.PAGESIZE
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                $scope.data.componentsList = data.result[0].votes;
                $scope.status.page = {
                    CURRPAGE: data.result[0].pageinfo.number,
                    PAGESIZE: data.result[0].pageinfo.size,
                    PAGECOUNT: data.result[0].pageinfo.total_pages,
                    ITEMCOUNT: data.result[0].pageinfo.total_elements,
                    COPYCURRPAGE: data.result[0].pageinfo.number
                };
            });
        }
    }]);
